import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
// import { Http } from '@angular/common/http';
import { tokenNotExpired, JwtHelper } from 'angular2-jwt';
import { Router } from '@angular/router';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { AuthService } from "angular2-social-login";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../environments/environment';
import { UserLogin } from '../models/UserLogin';

@Injectable()
export class AppAuthService {
  currentUser: any;

  constructor(
    private http: Http,
    protected router: Router,
    private socialauth: AuthService) {
    let token = localStorage.getItem('token');
    if (token) {
      let jwt = new JwtHelper();
      this.currentUser = jwt.decodeToken(token).data;
      // console.log('===== currentUser =====', this.currentUser)
    }
  }

  pinghttps() {
    return this.http.post('https://www.edicolamanager.it:3071/ping', { })
      .map(response => {
        let result = response.json();
        console.log(result);
        return {
          result: result,
        }
      })
  }

  login(credentials) {
    console.log('============ login ============');
    console.log(credentials);
    console.log(environment.server.url);
    console.log('============ login ============');
    return this.http.post(environment.server.url + '/user/authenticate', credentials)
      .map(response => {
        let result = response.json();
        console.log(result);
        let jwt = new JwtHelper();
        if (result) {
          if (result.success && result.token) {
            localStorage.setItem('token', result.token);
            this.currentUser = jwt.decodeToken(localStorage.getItem('token')).data;
            console.log('===== currentUser =====', this.currentUser)
          }
          // return result.success;
          return {
            success: result.success,
            credentials: credentials
          }
        } else {
          // return false;
          return {
            success: false,
            credentials: credentials
          }
        }
      })
  }

  socialLogin(provider): Observable<any> {
    return this.socialauth.login(provider)
      .map((sub: any) => sub)
      .flatMap((sub: any) => {
        return this.login({ userid: new UserLogin(sub).email, social: true })
      })
  }

  get photoUrl() {
    return this.currentUser ? environment.server.url + '/static/media/users/' + this.currentUser.photo : null;
  }

  get photoUrl2() {
    return this.currentUser ? 'https://api.adorable.io/avatars/64/' + this.currentUser.email + '.png' : null;
  }

  get avatar() {
    return {
      size: 40,
      background: '#4285f4', // by default it will produce dynamic colors
      fontColor: '#FFFFFF',
      border: "0",
      isSquare: false,
      text: this.currentUser ? this.currentUser.name : ''
    };
  }

  logout() {
    localStorage.removeItem('token');
    this.currentUser = null;
    this.router.navigate(['/login']);

    this.socialauth.logout().subscribe(
      (data) => {
        console.log('social logout', data)
      }
    )
  }

  isLoggedIn() {
    return tokenNotExpired('token');
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts